import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { FieldConfigKey, UserType } from '../../util/enums';
import { storableError } from '../../util/errors';
import { getCompanyNamesAndIds } from '../../util/listingDataExtraction';
import { parse } from '../../util/urlHelpers';
export const TOS_ASSET_NAME = 'terms-of-service';
export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';

export const SET_REFERRER_ID = 'app/AuthenticationPage/SET_REFERRER_ID';
export const FETCH_AGENCY_LISTINGS_REQUEST = 'app/AuthenticationPage/FETCH_AGENCY_LISTINGS_REQUEST';
export const FETCH_AGENCY_LISTINGS_SUCCESS = 'app/AuthenticationPage/FETCH_AGENCY_LISTINGS_SUCCESS';
export const FETCH_AGENCY_LISTINGS_ERROR = 'app/AuthenticationPage/FETCH_AGENCY_LISTINGS_ERROR';
const initialState = {
  searchInProgress: false,
  searchListingsError: null,
  agencies: [],
  referrerId: null,
};

const AuthenticationPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_AGENCY_LISTINGS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
        agencies: [],
        searchListingsError: null,
      };
    case FETCH_AGENCY_LISTINGS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        agencies: payload,
        searchListingsError: null,
      };
    case FETCH_AGENCY_LISTINGS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, searchInProgress: false, agencies: [], searchListingsError: payload };

    case SET_REFERRER_ID:
      return { ...state, referrerId: payload };
    default:
      return state;
  }
};

export default AuthenticationPageReducer;

// ================ Selectors ================ //
export const getAgencies = state => state.AuthenticationPage.agencies || [];
export const getReferrerIdSelector = state => state.AuthenticationPage.referrerId;

// ================ Action creators ================ //

export const fetchAgencyListingsRequest = () => ({
  type: FETCH_AGENCY_LISTINGS_REQUEST,
});

export const fetchAgencyListingsSuccess = response => ({
  type: FETCH_AGENCY_LISTINGS_SUCCESS,
  payload: response,
});

export const fetchAgencyListingsError = e => ({
  type: FETCH_AGENCY_LISTINGS_ERROR,
  error: true,
  payload: e,
});
export const setreferrerId = id => ({
  type: SET_REFERRER_ID,
  payload: id,
});

export const fetchAgencies = () => async (dispatch, getState, sdk) => {
  dispatch(fetchAgencyListingsRequest());
  try {
    const response = await sdk.listings.query({
      pub_listingCategory: FieldConfigKey.AGENCY_FIELD,
    });
    const listings = response?.data?.data || [];

    const agencies = getCompanyNamesAndIds(listings);
    const agenciesOptions = agencies?.map(agency => ({
      label: agency?.name,
      option: agency?.name,
      id: agency?.id,
    }));
    dispatch(fetchAgencyListingsSuccess(agenciesOptions));
  } catch (error) {
    dispatch(fetchAgencyListingsError(storableError(error)));
  }
};
export const loadData = (params, search) => (dispatch, getState) => {
  const userType = params?.userType;
  const queryParams = parse(search);
  const referral_code = queryParams.referral_code;
  if (userType === UserType.TALENT) {
    dispatch(fetchAgencies());
  }

  if (queryParams.referral_code) {
    const [referrerId] = referral_code.split('_');
    if (referrerId) {
      dispatch(setreferrerId(referrerId));
    }
  }

  const pageAsset = {
    termsOfService: `content/pages/${TOS_ASSET_NAME}.json`,
    privacyPolicy: `content/pages/${PRIVACY_POLICY_ASSET_NAME}.json`,
  };
  return dispatch(fetchPageAssets(pageAsset, true));
};
